;

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = displayValuesFor;
function displayValuesFor(props, moreProps) {
	var currentItem = moreProps.currentItem;

	return currentItem;
}
